import Summary from '@/views/Summary.vue'
import SummaryBankTransfer from '@/views/SummaryBankTransfer.vue'
import type { RouteLocationNormalized } from 'vue-router'

export default [
  {
    path: '/podsumowanie',
    name: 'Summary',
    component: Summary,
    meta: {
      title: 'Wybór dziecka - Podsumowanie - Ścieżka Wyboru Dzieci',
      metaTags: [{ name: 'robots', content: 'noindex' }]
    },
    children: [
      {
        path: 'blad',
        name: 'SummaryFailure',
        component: Summary,
        meta: {
          title: 'Wybór dziecka - Podsumowanie - Ścieżka Wyboru Dzieci',
          metaTags: [{ name: 'robots', content: 'noindex' }]
        }
      },
      {
        path: 'kolejna-rata',
        name: 'SummaryNextInstallment',
        component: Summary,
        meta: {
          title: 'Wybór dziecka - Podsumowanie - Ścieżka Wyboru Dzieci',
          metaTags: [{ name: 'robots', content: 'noindex' }]
        }
      }
    ]
  },
  {
    path: '/blankiet',
    name: 'SummaryBankTransfer',
    component: SummaryBankTransfer,
    meta: {
      title: 'Wybór dziecka - Podsumowanie - Ścieżka Wyboru Dzieci',
      metaTags: [{ name: 'robots', content: 'noindex' }]
    },
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized) =>
      from.name === 'FormOfDonorData' || { name: 'Home' }
  }
]
